import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7f7f43da-3b57-4afc-b713-37b9e0dc724f",
    content: "Yes, a symphonic orchestra can play in any volume.",
    options: {},
  },
  {
    id: "225e9ae8-97a8-4286-80a6-c553b44fc926",
    content: "No, a bigger volume is required to avoid excessive loudness.",
    options: {},
  },
  {
    id: "f6f92408-9d61-4fd9-85dc-8c3f6fc849b7",
    content: "No, a smaller volume is required for better cross-communication between musicians.",
    options: {},
  },
  {
    id: "4c2568bb-d9cd-48ea-9444-0d22dc6ae9c7",
    content: "No, this volume isn’t suitable for a symphonic orchestra but it is suitable for chamber music.",
    options: {},
  },
];

export const task: Task = {
  id: "3597ca21-bfc9-41e3-a651-49212e9c252a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: ["225e9ae8-97a8-4286-80a6-c553b44fc926", "4c2568bb-d9cd-48ea-9444-0d22dc6ae9c7"],
};
